import Cookies from 'universal-cookie'
import { SEGMENT_ANONYMOUS_ID_COOKIE_NAME } from './consts'

export default function getSegmentAnonymousIdFromClientCookie():
  | string
  | undefined {
  const cookies = new Cookies()
  return cookies.get(SEGMENT_ANONYMOUS_ID_COOKIE_NAME)
}
